module.exports = __webpack_public_path__ + "static/media/homesite-logo.e28afc04.svg";